import {
	AppBar,
	Box,
	Breadcrumbs,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	Divider,
	FormControlLabel,
	FormControl,
	Grid,
	IconButton,
	InputLabel,
	MenuItem,
	Paper,
	Select,
	SelectChangeEvent,
	Stack,
	styled,
	Switch,
	TextField,
	Toolbar,
	Typography,
	useTheme,
	Alert,
} from '@mui/material'
import {
	alertModal,
	autoCellPhone,
	confirmAlert,
	hexToRgba,
	timerAlert,
} from 'util/util'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import RotateLeftIcon from '@mui/icons-material/RotateLeft'
import ContentPasteSearchTwoToneIcon from '@mui/icons-material/ContentPasteSearchTwoTone'
import SaveAsTwoToneIcon from '@mui/icons-material/SaveAsTwoTone'
import DeleteForeverTwoToneIcon from '@mui/icons-material/DeleteForeverTwoTone'
import { useEffect, useState } from 'react'
import {
	DataGridPremium,
	GridColDef,
	GridSelectionModel,
	useGridApiRef,
} from '@mui/x-data-grid-premium'
import { getSettings } from 'helpers/storage'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider/LocalizationProvider'
import { PageBg } from 'components/ComponentStyles'
import {
	apiReportTypeList,
	apiRptCodeListByReportCode,
	httpGet,
	httpPost,
} from 'api/api'
import { valuesInIterator } from 'util/objectUtil'
import CloseIcon from '@mui/icons-material/Close'
import ClientSearchPopup from 'views/test/clientSearchPopup'
import { selectuserInfo } from 'hooks/userInfo'
import { useSelector } from 'react-redux'

const PageBg2 = styled('div')(({ theme }) => ({
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	padding: '1rem',
	borderRadius: '0.5rem',
	background: `${hexToRgba(theme.palette.custom.wrapper, 1)}`,
	// filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.1))',
	[`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
		flexDirection: 'column',
		borderRadius: 0,
	},
	// backdropFilter: 'blur(10px)',
}))

const PageWrap = styled('div')(({ theme }) => ({
	marginBottom: '1rem',
	position: 'relative',
	top: '0',
	left: '0',
	right: '0',
	zIndex: '110',
	[`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
		//marginLeft: '-1.5rem',
		//marginRight: '-1.5rem',
		top: '0',
		//borderRadius: '0',
	},
}))

const BtnBox = styled(Box)(({ theme }) => ({
	// [`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
	// 	marginTop: '1rem',
	// },
}))

const TitleText = styled(Typography)(({ theme }) => ({
	[`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
		display: 'none',
	},
}))

const locales = ['ko'] as const

// 조회 설정
type SearchType = {
	clientID: number | null
	reportTypeCode: string
	partCode: string
	isActive: boolean | null
}

const initialSearch: SearchType = {
	clientID: null,
	reportTypeCode: '0',
	partCode: '0',
	isActive: null,
}

// 그리드 데이터 설정
type GridDataType = {
	rptTypeCode: string
	reportName: string
	webReportName: string
	partCode: number
	IsActive: boolean
	ResultType: 'A' | 'N' | 'P'
	TemplateID: number
	ClientID: number
	TemplateName: string
	TemplateText: string
	isMine?: number
}

type partCodeType = {
	partName: string
	partCode: string
}

type rptCodeType = {
	rptTypeCode: string
	reportName: string
	webReportName: string
	partCode: string
	active: boolean
}

type templateType = {
	TemplateID: number | null
	ClientID: number | null
	TemplateName: string
	TemplateText: string
	RptTypeCode: string
	ResultType: 'A' | 'N' | 'P'
	IsActive: boolean
	reportName: string
	isMine?: number
}

const AutoSmsClientSetting = () => {
	const theme = useTheme()
	const isMdUp = theme.breakpoints.up('md')
	const userInfo = useSelector(selectuserInfo)

	const gridColumns: GridColDef[] = [
		{
			field: 'rptTypeCode',
			headerName: '보고서코드',
			width: 150,
			align: 'center',
			headerAlign: 'center',
		},
		{
			field: 'webReportName',
			headerName: '보고서명',
			width: 300,
			align: 'center',
			headerAlign: 'center',
		},
		{
			field: 'ResultType',
			headerName: '결과 전송 유형',
			width: 150,
			align: 'center',
			headerAlign: 'center',
			renderCell: (params) => {
				const value = params.value as 'A' | 'N' | 'P'
				let displayText = ''
				switch (value) {
					case 'A':
						displayText = '전체 전송'
						break
					case 'N':
						displayText = 'Negative만 전송'
						break
					case 'P':
						displayText = 'Positive만 전송'
						break
					default:
						displayText = ''
				}
				return <span>{displayText}</span>
			},
		},
		{
			field: 'IsActive',
			headerName: '활성화',
			width: 150,
			align: 'center',
			headerAlign: 'center',
			renderCell: (params) => {
				return (
					<span
						style={{
							backgroundColor: params.value ? '#4caf50' : '#ccc',
							color: '#fff',
							padding: '2px 6px',
							borderRadius: '4px',
							fontSize: '0.8rem',
							display: 'inline-block',
							minWidth: '70px',
							textAlign: 'center',
						}}
					>
						{params.value ? '사용' : '미사용'}
					</span>
				)
			},
		},
		{
			field: 'isMine',
			headerName: '기본 양식/사용자 양식',
			width: 150,
			align: 'center',
			headerAlign: 'center',
			renderCell: (params) => {
				const { isMine } = params.row
				return (
					<span
						style={{
							backgroundColor: isMine ? '#4caf50' : '#ccc',
							color: '#fff',
							padding: '2px 6px',
							borderRadius: '4px',
							fontSize: '0.8rem',
							display: 'inline-block',
							minWidth: '70px',
							textAlign: 'center',
						}}
					>
						{isMine === 1 ? '사용자 양식' : '기본 양식'}
					</span>
				)
			},
		},
		{
			field: 'button',
			headerName: '',
			width: 150,
			align: 'center',
			headerAlign: 'center',
			renderCell: (params) => {
				const { TemplateID } = params.row
				return (
					<Button
						color={TemplateID ? 'primary' : 'secondary'}
						variant="contained"
						size="small"
						onClick={() => openSmsTemplate(params.row)}
					>
						{TemplateID ? '보기' : '생성'}
					</Button>
				)
			},
		},
	]

	const gridRef = useGridApiRef()

	const env = getSettings()
	const [locale] = useState<(typeof locales)[number]>('ko')

	const [search, setSearch] = useState<SearchType>({
		...initialSearch,
		clientID: userInfo.infoType === 'C' ? userInfo.clientID : null, // 거래처id
	})

	const [disabledReset, setDisabledReset] = useState(false)
	const [disabledSearch, setDisabledSearch] = useState(false)
	const [selectionModel, setSelectionModel] = useState<GridSelectionModel>([])

	// 조회조건 (검체종류)
	const [testCdList, setTestCdList] = useState<any>([])

	// 파트 코드 목록
	const [partCodeList, setPartCodeList] = useState<partCodeType[]>([])
	// 보고서 종류 코드 목록
	const [rptTypeList, setRptTypeList] = useState<rptCodeType[]>([])

	const [gridData, setGridData] = useState<GridDataType[]>([])
	const [gridLoading, setGridLoading] = useState(false)
	const [gridPageSize, setGridPageSize] = useState(env.row ? env.row : 100)

	const actionReset = () => {
		setSearch({
			...initialSearch,
			clientID: userInfo.infoType === 'C' ? userInfo.clientID : null, // 거래처id
		})
		actionSearch()
	}

	const actionSearch = () => {
		httpGet('autoSms/client/template/list', search).then((res) => {
			console.log(res)
			setRptTypeList(res)
			setGridData(res)
		})
	}

	const actionSave = () => {
		// 선택된 데이터 row 확인
		const selectedRows = gridRef.current.getSelectedRows()
		const valuesArray = valuesInIterator(selectedRows)
		if (valuesArray.length === 0) {
			alertModal('저장할 데이터를 선택해주세요.', 'warning', () => {})
			return
		}

		confirmAlert(
			'선택한 데이터를 저장하시겠습니까?',
			() => {
				setGridLoading(true)
			},
			() => {},
		)
	}

	const actionDel = () => {}

	const onKeyUp = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === 'Enter') actionSearch()
	}

	/**
	 * 검체종류 select
	 * @param e
	 */
	const searchTestCdOnChange = (e: SelectChangeEvent<string>): void => {
		const selectedPartCode = e.target.value

		httpGet('autoSms/partCode', { partCode: selectedPartCode }).then((res) => {
			console.log(res)
			setRptTypeList(res)

			setSearch((prev) => ({
				...prev,
				partCode: selectedPartCode,
				reportTypeCode: res?.[0]?.rptTypeCode ?? '0',
			}))
			setGridData(res)
		})
	}

	const [smsTemplateIsOpen, setSmsTemplateIsOpen] = useState(false)
	const [smsTemplateData, setSmsTemplateData] = useState<templateType | null>(
		null,
	)
	const saveSmsTemplate = () => {
		console.log('saveSmsTemplate')
		console.log(smsTemplateData)
		if (
			smsTemplateData?.TemplateName.trim() === '' ||
			smsTemplateData?.TemplateText.trim() === ''
		) {
			alertModal('템플릿 이름과 내용을 입력해주세요.', 'warning', () => {})
			return
		}
		if (smsTemplateData?.RptTypeCode.trim() === '') {
			alertModal('보고서코드를 확인해주세요.', 'warning', () => {})
			return
		}
		// {수진자명}, {검사명}, {결과} 포함 여부 체크
		const templateText = smsTemplateData?.TemplateText || ''
		if (
			!templateText.includes('{수진자명}') ||
			!templateText.includes('{검사명}') ||
			!templateText.includes('{결과}')
		) {
			alertModal(
				'템플릿 내용에 {수진자명}, {검사명}, {결과} 변수를 포함해야 합니다.',
				'warning',
				() => {},
			)
			return
		}

		// 허용된 변수 외 다른 {} 변수가 포함되어 있는지 체크
		const regex = /{([^}]+)}/g
		let match
		const allowedVariables = [
			'수진자명',
			'검사명',
			'결과',
			'차트번호',
			'나이',
			'성별',
		]
		while ((match = regex.exec(templateText)) !== null) {
			const variableName = match[1]
			if (!allowedVariables.includes(variableName)) {
				alertModal(
					`템플릿 내용에 허용되지 않은 변수 {${variableName}}가 포함되어 있습니다.`,
					'warning',
					() => {},
				)
				return
			}
		}

		if (userInfo.infoType === 'W' || userInfo.infoType === 'S') {
			if (smsTemplateData) {
				smsTemplateData.ClientID = search.clientID
			}
		}

		console.log(smsTemplateData)

		confirmAlert(
			'데이터를 저장하시겠습니까? 기존에 생성된 템플릿이 있을 경우 덮어쓰기가 됩니다.',
			async () => {
				const request = {
					ClientID: userInfo.infoType === 'C' ? userInfo.clientID : search.clientID,
					json: smsTemplateData,
				}
				httpPost('autoSms/client/template/save', request).then((res) => {
					alertModal('저장되었습니다.', 'success', () => {})
					closeSmsTemplate()
					actionSearch()
				})
			},
			() => {},
		)
	}

	const [canEditTemplate, setCanEditTemplate] = useState(false)
	const openSmsTemplate = (data: GridDataType | null = null) => {
		console.log(data)
		// const isMine =
		// 	userInfo.infoType === 'C' && userInfo.clientID === data?.ClientID ? 1 : 0
		setSmsTemplateData({
			TemplateID: data?.TemplateID || null,
			ClientID: data?.ClientID || null,
			TemplateName: data?.TemplateName || '',
			TemplateText: data?.TemplateText || '',
			RptTypeCode: data?.rptTypeCode || '',
			IsActive: data?.IsActive || false,
			reportName: data?.reportName || '',
			ResultType: data?.ResultType || 'A',
			isMine: data?.isMine || 0,
		})
		setSmsTemplateIsOpen(true)
		// smsTemplateData.isMine 이 1이거나, smsTemplateData.ClientID 가 null 이면 수정 가능
		// const canEditTemplate =
		// 	smsTemplateData !== null &&
		// 	(smsTemplateData.isMine === 1 || smsTemplateData?.ClientID === null)
		// const canEditTemplate = smsTemplateData
		// 	? !(
		// 			(smsTemplateData.isMine === 0 && smsTemplateData.ClientID !== null) ||
		// 			(userInfo.infoType === 'C' &&
		// 				userInfo.clientID !== smsTemplateData.ClientID &&
		// 				smsTemplateData.ClientID !== null)
		// 		)
		// 	: false
		// setCanEditTemplate(canEditTemplate)
	}
	const closeSmsTemplate = () => {
		setSmsTemplateIsOpen(false)
		setSmsTemplateData(null)
	}

	// SMS 발신 부가 정보 (전화번호, 발신 예정 시간 등)
	const [senderPhoneNumber, setSenderPhoneNumber] = useState('')
	const getSenderPhoneNumber = (clientID: number) => {
		httpGet('autoSms/client/smsPlan', { clientID }).then((res) => {
			console.log(res)
			setSenderPhoneNumber(res?.PhoneNumber || '')
		})
	}

	// 내부사용자일 경우 거래처 선택 팝업
	const [clientDialogOpen, setClientDialogOpen] = useState(false)
	const [searchClientName, setSearchClientName] = useState('')
	const clientDialogClose = () => {
		setClientDialogOpen(false)
	}
	const clientPopupOpenAction = () => {
		setClientDialogOpen(true)
	}
	const clientPopupSubmit = (e: any) => {
		console.log(e)
		setSearchClientName(e.ClientName)
		setSearch({
			...search,
			clientID: e.ClientID,
		})
		getSenderPhoneNumber(e.ClientID)
		setClientDialogOpen(false)
	}

	useEffect(() => {
		apiReportTypeList().then((res) => {
			console.log(res)
			setTestCdList(res)
		})
		if (userInfo.infoType === 'C') {
			actionSearch()
			getSenderPhoneNumber(userInfo.clientID)
		}
	}, [])

	return (
		<>
			<ClientSearchPopup
				dialogOpen={clientDialogOpen}
				dialogClose={clientDialogClose}
				popupSubmit={clientPopupSubmit}
			/>
			<Dialog
				fullScreen={isMdUp ? false : true}
				open={smsTemplateIsOpen}
				onClose={closeSmsTemplate}
				maxWidth="sm"
			>
				<AppBar sx={{ position: 'relative' }}>
					<Toolbar variant="dense">
						<Typography
							sx={{ ml: 2, flex: 1 }}
							variant="h6"
							component="div"
						>
							{smsTemplateData?.reportName || ''}{' '}
							{smsTemplateData?.isMine === 1 ? '사용자 양식' : '기본 양식'} 템플릿
						</Typography>
						<IconButton
							edge="end"
							color="inherit"
							onClick={closeSmsTemplate}
							aria-label="close"
						>
							<CloseIcon />
						</IconButton>
					</Toolbar>
				</AppBar>
				<DialogContent>
					<Box>
						<TextField
							label="템플릿 이름"
							fullWidth
							margin="normal"
							value={smsTemplateData?.TemplateName || ''}
							onChange={(e) =>
								setSmsTemplateData((prev) =>
									prev ? { ...prev, TemplateName: e.target.value } : null,
								)
							}
							disabled={!smsTemplateData?.isMine && smsTemplateData?.ClientID !== null}
						/>
						<TextField
							label="결과 전송 유형"
							fullWidth
							margin="normal"
							select
							value={smsTemplateData?.ResultType || 'A'}
							onChange={(e) =>
								setSmsTemplateData((prev) =>
									prev
										? { ...prev, ResultType: e.target.value as 'A' | 'N' | 'P' }
										: null,
								)
							}
							disabled={!smsTemplateData?.isMine && smsTemplateData?.ClientID !== null}
						>
							<MenuItem value="A">전체 전송</MenuItem>
							<MenuItem value="N">음성만 전송</MenuItem>
							<MenuItem value="P">양성만 전송</MenuItem>
						</TextField>
						<TextField
							label="템플릿 내용"
							fullWidth
							multiline
							rows={10}
							margin="normal"
							value={smsTemplateData?.TemplateText || ''}
							onChange={(e) =>
								setSmsTemplateData((prev) =>
									prev ? { ...prev, TemplateText: e.target.value } : null,
								)
							}
							disabled={!smsTemplateData?.isMine && smsTemplateData?.ClientID !== null}
						/>
						{smsTemplateData?.isMine === 1 || smsTemplateData?.ClientID === null ? (
							<FormControlLabel
								control={
									<Switch
										checked={smsTemplateData?.IsActive ?? false}
										onChange={(e) =>
											setSmsTemplateData((prev) =>
												prev ? { ...prev, IsActive: e.target.checked } : null,
											)
										}
									/>
								}
								label="활성화"
							/>
						) : null}
					</Box>
					<Box>
						<Typography
							variant="body2"
							color="warning.main"
						>
							{'템플릿 내용에 아래 내용의 변수를 사용하여 구성해야 합니다.'}
							<br />
							{'필수입력 변수 : {수진자명},{검사명},{결과}'}
							<br />
							<span style={{ color: '#4b7bec' }}>
								{'선택입력 변수 : {차트번호},{나이},{성별}'}
							</span>
						</Typography>
						<Box sx={{ background: '#efefef', p: 2, mt: 1, borderRadius: '0.5rem' }}>
							<Typography
								variant="body2"
								color="text.secondary"
							>
								{
									'예시: {수진자명}님, {검사명}의 결과는 {결과}입니다. 문의 사항은 02-1234-1234로 연락주세요.'
								}
								<br />
								본인이 아닐 경우 병원으로 문의 바랍니다.
							</Typography>
						</Box>
					</Box>
				</DialogContent>
				<Divider />
				<DialogActions>
					{smsTemplateData?.isMine === 1 || smsTemplateData?.ClientID === null ? (
						<Button
							variant="contained"
							color="primary"
							onClick={saveSmsTemplate}
						>
							저장
						</Button>
					) : null}
				</DialogActions>
			</Dialog>
			<Stack
				sx={{
					position: 'sticky',
					top: '50px',
					zIndex: 100,
					padding: '0.5rem',
					borderRadius: '0.5rem',
					backgroundColor:
						theme.palette.mode === 'dark' ? 'rgba(50, 48, 54, 1)' : '#fff',
					'@media (max-width: 600px)': {
						position: 'relative',
						paddingTop: '15px',
						top: '0px',
					},
				}}
			>
				<PageWrap style={{ marginBottom: '0.5rem' }}>
					<PageBg2 sx={{ padding: '0.3rem 0.3rem 0rem 0.5rem' }}>
						<Breadcrumbs
							separator={<NavigateNextIcon fontSize="small" />}
							aria-label="breadcrumb"
							sx={{
								'@media (max-width: 900px': {
									display: 'none',
								},
							}}
						>
							<TitleText
								key="3"
								color="text.primary"
								sx={{ fontWeight: '500', fontSize: 17 }}
							>
								검사결과 전송 설정
							</TitleText>
						</Breadcrumbs>
						<BtnBox>
							<div>
								{/* <span>
									<Button
										size="small"
										color="success"
										variant="contained"
										startIcon={isMdUp && <RotateLeftIcon />}
										sx={{
											marginRight: '0.5rem',
											padding: isMdUp ? '4px 10px' : '4px 6px',
											minWidth: isMdUp ? '64px' : '50px',
										}}
										disabled={disabledReset}
										onClick={actionReset}
									>
										초기화
									</Button>
								</span> */}
								<span>
									<Button
										size="small"
										color="primary"
										variant="contained"
										startIcon={isMdUp && <ContentPasteSearchTwoToneIcon />}
										sx={{
											marginRight: '0.5rem',
											padding: isMdUp ? '4px 10px' : '4px 6px',
											minWidth: isMdUp ? '64px' : '50px',
										}}
										disabled={disabledSearch}
										onClick={actionSearch}
									>
										조회
									</Button>
								</span>
								{/* <span>
									<Button
										color="secondary"
										size="small"
										variant="contained"
										startIcon={isMdUp && <SaveAsTwoToneIcon />}
										sx={{
											marginRight: '0.5rem',
											padding: isMdUp ? '4px 10px' : '4px 6px',
											minWidth: isMdUp ? '64px' : '50px',
										}}
										onClick={actionSave}
										disabled={true}
									>
										저장
									</Button>
								</span>
								<span>
									<Button
										color="warning"
										size="small"
										variant="contained"
										startIcon={isMdUp && <DeleteForeverTwoToneIcon />}
										sx={{
											padding: isMdUp ? '4px 10px' : '4px 6px',
											minWidth: isMdUp ? '64px' : '50px',
										}}
										onClick={actionDel}
										disabled={true}
									>
										삭제
									</Button>
								</span> */}
							</div>
						</BtnBox>
					</PageBg2>
				</PageWrap>
				<Box
					onKeyUp={onKeyUp}
					sx={{
						borderTop:
							theme.palette.mode === 'dark'
								? '1px solid rgba(81, 81, 81, 1)'
								: '1px solid #ccc',
						paddingTop: '1rem',
					}}
				>
					<LocalizationProvider
						dateAdapter={AdapterDayjs}
						adapterLocale={locale}
					>
						<Grid
							container
							spacing={1}
							sx={{ marginTop: '0.1rem' }}
						>
							{/* <Grid
								item
								xs={6}
								sm={3}
								md={2}
							>
								<FormControl fullWidth>
									<InputLabel id="date-range-select-label">학부</InputLabel>
									<Select
										labelId="date-range-select-label"
										id="date-range-simple-select"
										label="학부"
										value={search.partCode}
										onChange={searchTestCdOnChange}
										size={'small'}
									>
										<MenuItem value={'0'}>전체</MenuItem>
										{testCdList &&
											testCdList.length > 0 &&
											testCdList.map((item: partCodeType) => (
												<MenuItem
													key={item.partCode}
													value={item.partCode}
												>
													{item.partName}
												</MenuItem>
											))}
									</Select>
								</FormControl>
							</Grid> */}
							{(userInfo.infoType === 'S' || userInfo.infoType === 'W') && (
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
								>
									<TextField
										label="거래처"
										variant="outlined"
										size="small"
										type="text"
										fullWidth
										aria-readonly={true}
										value={searchClientName}
										onClick={clientPopupOpenAction}
									/>
								</Grid>
							)}
							<Grid
								item
								xs={12}
								md={6}
							>
								<Typography variant="body1">
									병원 발신번호 : {autoCellPhone(senderPhoneNumber)}
									<br />
									발신번호 변경 시, 본원으로 문의 바랍니다.
								</Typography>
							</Grid>
						</Grid>
					</LocalizationProvider>
				</Box>
			</Stack>
			<Paper
				elevation={0}
				sx={{ width: '100%', overflow: 'hidden', mt: 2 }}
			>
				<Grid container>
					<Grid
						item
						xs={12}
					>
						<PageBg>
							<Box
								sx={{
									height: 'calc(100vh - 300px)',
									'@media (max-width: 1199px)': {
										height: '400px',
										overflow: 'auto',
									},
								}}
							>
								<DataGridPremium
									columns={gridColumns}
									rows={gridData}
									apiRef={gridRef}
									getRowId={(row) => row.TemplateID}
									loading={gridLoading}
									pageSize={gridPageSize}
									onPageSizeChange={(newPageSize) => {
										setGridPageSize(newPageSize)
									}}
									rowsPerPageOptions={[50, 100, 200]}
									pagination
									// checkboxSelection
									onSelectionModelChange={(newSelectionModel) => {
										setSelectionModel(newSelectionModel)
									}}
									selectionModel={selectionModel}
									disableMultipleSelection={true}
									initialState={{
										columns: {
											columnVisibilityModel: {
												RowNum: false,
											},
										},
									}}
								/>
							</Box>
						</PageBg>
					</Grid>
				</Grid>
			</Paper>
		</>
	)
}

export default AutoSmsClientSetting
